module.exports = __webpack_public_path__ + "static/media/coding.279a2117.png";